import { progressBarPercentIcon } from '~/assets/icons/js/progressBarPercentIcon';
export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const backgrounds = ['success', 'info', 'warning', 'danger'];
    const BM = editor.BlockManager;

    var model = MODEL.extend({

        defaults: {
            ...MODEL.prototype.defaults,
            tagName: 'div',
            attributes: {
                "data-order-step": "0",
                "data-lg-type": "C-PROGRESS-BAR-PERCENT",
                "aria-expanded": true
            },
            classes: ["progress"],
            components: [
                {
                    tagName: 'div',
                    attributes: {
                        class: "progress-bar progress-bar-striped",
                        role: "progressbar",
                        "aria-valuenow": 0,
                        "aria-valuemin": 0,
                        "aria-valuemax": 100,
                    },
                    style:{
                        width: "25%"
                    }
                }
            ],
            traits: [
            ].concat(MODEL.prototype.defaults.traits)

        }
    }, {
        isComponent(el) {
            if (el && el.getAttribute && el.getAttribute('data-lg-type') == "C-PROGRESS-BAR-PERCENT")
                return { type: 'C-PROGRESS-BAR-PERCENT' }
        }
    });

    var view = VIEW.extend({

        init() {
        },

    });

    DOMC.addType('C-PROGRESS-BAR-PERCENT', {
        model: model,
        view: view,
    });

    BM.add('B-PROGRESS-BAR-PERCENT', {
        label: "PROGRESS BAR PERCENT",
        content: {
            type: 'C-PROGRESS-BAR-PERCENT',
        },
        category: "ADVANCE COMPONENT",
        media: progressBarPercentIcon,
    });
};